import { createSlice } from "@reduxjs/toolkit";



interface RootState {
    timeLine: boolean;
    doc: boolean;
    selectedPlanet:any
    hoverStage1:any
    hoverStage2:any
    hoverStage3:any
    hoverStage4:any
    hoverStage5:any

  }
  
  const initialState: RootState = {
    selectedPlanet:null,
    timeLine:true,
    doc:false ,
    hoverStage1:0,
    hoverStage2:0,
    hoverStage3:0,
    hoverStage4:0,
    hoverStage5:0,
    
  };
  

export const communitySlice = createSlice({
    name: "communityDetails",
    initialState,
    reducers: {
      setSelectedPlanet: (state: any, { payload }) => {
        state.selectedPlanet = payload;
  
      },
      setTimeLine: (state: any, { payload }) => {
        state.timeLine = payload;
       
      },
      setDoc: (state: any, { payload }) => {
        state.doc = payload;
  
      },
      setHoverStage1: (state: any, { payload }) => {
        state.hoverStage1 = payload;
  
      },
      setHoverStage2: (state: any, { payload }) => {
        state.hoverStage2 = payload;
  
      },
      setHoverStage3: (state: any, { payload }) => {
        state.hoverStage3 = payload;
  
      },
      setHoverStage4: (state: any, { payload }) => {
        state.hoverStage4 = payload;
  
      },
      setHoverStage5: (state: any, { payload }) => {
        state.hoverStage5 = payload;
  
      },
    },
  });


  export const { setTimeLine,setDoc,setSelectedPlanet ,setHoverStage1,setHoverStage2,setHoverStage3,setHoverStage4,setHoverStage5} = communitySlice.actions;

  export const getCommunityDetails = (state: any) => state.communityReducer;

  export default communitySlice.reducer;